var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.9561 9.19998H11.1561V4.39998C11.1561 3.95815 10.7979 3.59998 10.3561 3.59998C9.91423 3.59998 9.55605 3.95815 9.55605 4.39998V9.19998H4.75605C4.31423 9.19998 3.95605 9.55815 3.95605 9.99998C3.95605 10.4418 4.31423 10.8 4.75605 10.8H9.55605V15.6C9.55605 16.0418 9.91423 16.4 10.3561 16.4C10.7979 16.4 11.1561 16.0418 11.1561 15.6V10.8H15.9561C16.3979 10.8 16.7561 10.4418 16.7561 9.99998C16.7561 9.55815 16.3979 9.19998 15.9561 9.19998Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d64f3c7f4afdbd756b3c86763163b9b8.svg";
export { ForwardRef as ReactComponent };